var _rect, _path, _path2, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveChatNotValidatedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Message_validation2",
    "data-name": "Message validation2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.18,
    height: 31.71,
    viewBox: "0 0 32.18 31.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1241",
    "data-name": "Rectangle 1241",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(16.18)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "alert-circle",
    d: "M24.18,0a8,8,0,1,0,8,8A8,8,0,0,0,24.18,0Zm0,12.3a.77.77,0,1,1,.77-.77.77.77,0,0,1-.77.77h0Zm.83-7.74-.22,4.69a.62.62,0,0,1-1.24,0l-.22-4.69h0A.835.835,0,1,1,25,4.51v.06h0Z",
    fill: "#e80c08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M28.36,16.34v5.41a3.071,3.071,0,0,1-3.07,3.07H6.89L.75,30.96V6.41A3.071,3.071,0,0,1,3.82,3.34h12.2",
    fill: "none",
    stroke: "#647084",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_176",
    "data-name": "Line 176",
    x2: 6.79,
    transform: "translate(4.12 10.87)",
    fill: "none",
    stroke: "#647084",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_177",
    "data-name": "Line 177",
    x2: 11.6,
    transform: "translate(4.12 14.55)",
    fill: "none",
    stroke: "#647084",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_178",
    "data-name": "Line 178",
    x2: 14.69,
    transform: "translate(4.32 18.15)",
    fill: "none",
    stroke: "#647084",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatNotValidatedIcon);
export default __webpack_public_path__ + "static/media/live-chat-not-validated-icon.20b60b7e9c010e1ed2f5b05e76e1fdc6.svg";
export { ForwardRef as ReactComponent };